import React, { useRef } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { changeLayout, empLogin, getUserDataSuccess } from "store/actions";
import { layoutTypes } from "constants/layout";
import FormInput from "component/FormControl/FormInput";
import AppButton from "component/Buttons/AppButton";

const StaffLoginForm = props => {
  const formikRef = useRef();
  const dispatch = useDispatch();

  const onSuccess = response => {
    if (props?.onSuccess) {
      formikRef.current?.setSubmitting(false);
      props.onSuccess();
    } else {
      const data = {
        ...response?.data,
        uid: response.data.user_data.staff_id,
        username: response.data.user_data.name,
        role: "staff",
        email: response.data.user_data.email_addresses,
        pro_pic: response.data.user_data.profile_picture,
        user_token: response.data.user_data.staff_token,
        time_zone: response.data.user_data.time_zone,
        switch_token: response.data.switch_token,
      };
      dispatch(getUserDataSuccess(data));
      localStorage.setItem("uid", JSON.stringify(data.user_token));
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(response.data.user_data?.time_zone));
      localStorage.setItem("pro_pic", JSON.stringify(response.data.user_data?.profile_picture));

      dispatch(changeLayout(layoutTypes.HORIZONTAL));
      formikRef.current?.setSubmitting(false);
      if (response.data.user_data?.emp_account_status) {
        props.history.push("/staff-view");
      } else {
        props.history.push("/employee-profile");
      }
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize
      initialValues={{
        email: "",
        password: "",
        company_name: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().required("Please Enter Your Email"),
        password: Yup.string().required("Please Enter Your Password"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        dispatch(empLogin(values, onSuccess, () => setSubmitting(false), props.apiHeader));
      }}>
      {({ isSubmitting }) => {
        return (
          <Form>
            <Row>
              <Col md={12} className='mb-3'>
                <FormInput name='company_name' label='Company' labelClass='fw-normal' inputProps={{ placeholder: "Enter company name" }} />
              </Col>
              <Col md={12} className='mb-3'>
                <FormInput name='email' label='Email' labelClass='fw-normal' inputProps={{ placeholder: "Enter email" }} />
              </Col>
              <Col md={12} className='mb-3'>
                <FormInput
                  name='password'
                  label='Password'
                  withShowPassword
                  labelClass='fw-normal'
                  type='password'
                  inputProps={{ placeholder: "Enter password" }}
                />
              </Col>
              <Col md={12} className='text-center'>
                <AppButton type='submit' isSubmitting={isSubmitting} label={props.apiHeader ? "Verify" : "Log In"} />
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default withRouter(StaffLoginForm);
